const state = {
  showSideMenu: false,
};

const getters = {};

const actions = {};

const mutations = {
  showSideMenu(state, payload) {
    state.showSideMenu = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
